import { Typography } from "@/react/components/shared/uikit/Typography";
import { usePaywallCheckoutContext } from "@/react/contexts/Paywalls/paywallCheckoutContext";
import { getPaywallDescription, getPaywallTitle } from "../helpers/paywalls";
import { EventCover } from "./EventCover";
import { EventDetails } from "./EventDetails";
import { PaywallPricesWithPMC } from "./PaywallPricesWithPMC";
import { PaywallPricesWithoutPMC } from "./PaywallPricesWithoutPMC";
import "../styles.scss";

// In the future, our checkout system will rely on a paywall's contents association (polymorphic) to
// customize the checkout page as we are doing for events. For now, we are using the event association
// directly to display the event details.
export const PaywallPrices = () => {
  const { currentCommunityProcessorPaymentMethodConfigurationId, paywall } =
    usePaywallCheckoutContext();

  const title = getPaywallTitle(paywall);
  const description = getPaywallDescription(paywall);

  let PaywallPricesComponent;
  if (currentCommunityProcessorPaymentMethodConfigurationId) {
    PaywallPricesComponent = PaywallPricesWithPMC;
  } else {
    PaywallPricesComponent = PaywallPricesWithoutPMC;
  }

  return (
    <div className="flex flex-col gap-8">
      <EventCover event={paywall.event} />
      <div
        className="flex flex-col gap-3"
        data-testid="checkout-paywall-detail"
      >
        <Typography.TitleLg>{title}</Typography.TitleLg>
        <EventDetails event={paywall.event} className="pb-3" />
        {description && (
          <Typography.BodyMd>
            <span className="whitespace-pre-wrap">{description}</span>
          </Typography.BodyMd>
        )}
      </div>
      <div className="flex flex-col gap-4">
        <PaywallPricesComponent />
      </div>
    </div>
  );
};
